import {IModularHousesPublicOffer, ModularHouseOfferConstructionTech} from "@pg-mono/rp-api-routes";

export function getConstructionTechText(constructionOption: IModularHousesPublicOffer["construction_technology"]) {
    switch (constructionOption) {
        case ModularHouseOfferConstructionTech.WOODEN_ELEMENTS:
            return "Prefabrykat drewniany";
        case ModularHouseOfferConstructionTech.CONCRETE_ELEMENTS:
            return "Prefabrykat betonowy";
        case ModularHouseOfferConstructionTech.EXPANDED_CLAY_ELEMENTS:
            return "Prefabrykat keramzytowy";
        case ModularHouseOfferConstructionTech.WOODEN_FRAME:
            return "Szkielet drewniany";
        case ModularHouseOfferConstructionTech.STEEL_FRAME:
            return "Szkielet stalowy";
        case ModularHouseOfferConstructionTech.PREFABRICATED_MODULES:
            return "Moduły";
        default:
            // TODO >>> WYWALIC TO PRZED COMMITEM!
            return "";
        // throw new Error("Unknown construction technology");
    }
}
import {IModularHousesPublicOffer, ModularHouseOfferConstructionTech} from "@pg-mono/rp-api-routes";

export function getConstructionTechText(constructionOption: IModularHousesPublicOffer["construction_technology"]) {
    switch (constructionOption) {
        case ModularHouseOfferConstructionTech.WOODEN_ELEMENTS:
            return "Prefabrykat drewniany";
        case ModularHouseOfferConstructionTech.CONCRETE_ELEMENTS:
            return "Prefabrykat betonowy";
        case ModularHouseOfferConstructionTech.EXPANDED_CLAY_ELEMENTS:
            return "Prefabrykat keramzytowy";
        case ModularHouseOfferConstructionTech.WOODEN_FRAME:
            return "Szkielet drewniany";
        case ModularHouseOfferConstructionTech.STEEL_FRAME:
            return "Szkielet stalowy";
        case ModularHouseOfferConstructionTech.PREFABRICATED_MODULES:
            return "Moduły";
        default:
            // TODO >>> WYWALIC TO PRZED COMMITEM!
            return "";
        // throw new Error("Unknown construction technology");
    }
}
